import React from "react";

function Icon() {
  return (
    <img src="/images/logo.png" width="15%"/>
  );
}

export default Icon;